import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";

import { muiAbtn, muiBbtn } from "./style";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import CreativeImage from "./CreativeImage";
import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  deleteDoc,
} from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../firebase";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function Variants() {
  const [rows, setRows] = useState([]);
  const [isupdate, setisupdate] = useState(false);
  const [loading, setLoading] = useState(false); ///To check if data if loaded or not from collection.
  const [isProcessing, setisProcessing] = useState(false);
  const [open, setOpen] = useState(false);
  const [Name, setName] = useState("");
  const [DocId, setDocId] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    let active = true;
    const getData = async () => {
      setLoading(true);
      /////Getting the latest document first.
      const data = await getDocs(
        query(collection(db, "variant"), orderBy("name", "asc"))
      );
      //////Mapping Through App Documents And Then Saving them in rows useState.
      data.docs.map((document) => {
        setRows((row) => [
          ...row,
          {
            ...document.data(),
          },
        ]);
      });

      if (!active) {
        return;
      }

      setLoading(false);
      return () => {
        active = false;
      };
    };
    getData();
  }, []);

  const handleOpen = () => {
    setOpen(true);
    setName("");
  };
  const handleOpenUpdate = (name = "", id = "") => {
    setisupdate(true);
    setName(name);
    setDocId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setName("");
    setisupdate(false);
    setisProcessing(false);
  };

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setDocId(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDocId("");
    setisProcessing(false);
  };

  const deleteVariant = () => {
    setisProcessing(true);
    deleteDoc(doc(db, "variant", DocId))
      .then(() => {
        toast.info("Variant Deleted");
        handleCloseDialog();
        setRows(rows.filter((row) => row.id !== DocId));
      })
      .catch((error) => {
        handleCloseDialog();
        toast.error("Error! Unable to Delete Variant");
        console.log(error);
      });
  };

  const addVariant = () => {
    if (!Name) {
      toast.error("Variant Cant be Empty");
      return;
    }
    setisProcessing(true);

    if (isupdate) {
      updateDoc(doc(db, "variant", DocId), { name: Name })
        .then(() => {
          handleClose();
          toast.success("Variant Updated");
          setRows(
            rows.map((item) => {
              if (item.id === DocId) {
                return {
                  ...item,
                  name: Name,
                };
              } else {
                return item;
              }
            })
          );
        })
        .catch((error) => {
          handleClose();
          toast.error("Error! unable to Update Variant");
          console.log(error);
        });
    } else {
      const newDoc = doc(collection(db, "variant"));
      const doc_id = newDoc.id;
      setDoc(newDoc, { name: Name, id: doc_id })
        .then(() => {
          handleClose();
          toast.success("Variant Added");
          setRows((rows) => [{ name: Name, id: doc_id }, ...rows]);
        })
        .catch((error) => {
          handleClose();
          toast.error("Error! unable to Add Variant");
          console.log(error);
        });
    }
  };

  const columns = [
    // { field: "id", headerName: "ID", width: "60" },
    {
      field: "name",
      headerName: "",
      width: "500",
      align: "left",
    },

    {
      field: "Action",
      width: "400",
      align: "right",

      editable: false,
      renderCell: ActionButton,
    },
  ];

  function ActionButton(params) {
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          // startIcon={<CheckCircleIcon />}
          onClick={() => {
            handleOpenUpdate(params.row.name, params.row.id);
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          onClick={() => handleClickOpen(params.row.id)}
          // startIcon={<CancelIcon />}
        >
          Delete
        </Button>
      </>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,
        backgroundColor: "#212C62",
      }}
    >
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to Delete the Variant?"}
        </DialogTitle>

        {isProcessing ? (
          <LinearProgress />
        ) : (
          <DialogActions>
            <Button onClick={() => deleteVariant()}>Yes</Button>
            <Button onClick={handleCloseDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        )}
      </Dialog>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <Box style={{ display: "flex", justifyContent: "end" }}>
              <CloseIcon
                onClick={handleClose}
                style={{ cursor: "pointer", color: "gray" }}
              />
            </Box>
            <h2 className="mb-4" style={{ color: "#212C62" }} mb={3}>
              {!isupdate ? "Add New Variant" : "Update Variant"}
            </h2>

            <FormControl fullWidth size="small">
              <TextField
                className="mb-4"
                id="outlined-basic"
                label="Enter Name"
                variant="outlined"
                size="small"
                fullWidth
                value={Name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>

            <Button
              fullWidth
              className="mt-2 muibtn"
              variant="contained"
              color="primary"
              size="small"
              style={muiBbtn}
              disabled={isProcessing}
              onClick={() => addVariant()}
            >
              {isProcessing ? (
                <CircularProgress sx={{ color: "white" }} size={27} />
              ) : (
                <>
                  <AddIcon style={{ marginRight: 10 }} />
                  {!isupdate ? "Add Variant" : "Update Variant"}
                </>
              )}
            </Button>
          </form>
        </Box>
      </Modal>

      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6">
            <h1
              className="mb-4 py-4"
              style={{ textAlign: "left", color: "#212C62" }}
            >
              <b>All Variants</b>
            </h1>
            <Button
              variant="contained"
              color="primary"
              style={muiBbtn}
              size="small"
              // startIcon={<CheckCircleIcon />}
              onClick={() => handleOpen()}
            >
              Add New Variant
            </Button>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>All Variants</b>
          </h5>
          <DataGrid
            style={{ height: "65vh", width: "100%" }}
            columns={columns}
            rows={rows}
            // getRowId={(Rows) => Rows._id}
            pageSize={6}
            rowsPerPageOptions={[5]}
            loading={loading}
            disableColumnMenu={true}
            headerHeight={0}
            getRowSpacing={(params) => ({
              top: params.isFirstVisible ? 10 : 8,
              bottom: params.isLastVisible ? 0 : 8,
            })}
            disableSelectionOnClick
          />
        </div>
      </Card>
    </div>
  );
}
